function ToggleActive(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={45}
            height={20}
            viewBox="0 0 45 20"
            {...props}
        >
            <g fill="none" fillRule="evenodd">
                <rect width={45} height={20} fill="#FF4747" rx={10} />
                <path
                    fill="#FFF"
                    d="M19.875 5.505c.42.352.47.983.116 1.405l-6.11 7.282a1 1 0 01-1.403.128l-.036-.03a.96.96 0 01-.166-.179.956.956 0 01-.375-.21l-2.167-1.95a.996.996 0 01-.073-1.4l.032-.035a.997.997 0 011.4-.074l1.87 1.683 5.472-6.52a1 1 0 011.404-.13l.036.03z"
                />
                <circle cx={35} cy={10} r={9} fill="#FFF" />
            </g>
        </svg>
    );
}

export default ToggleActive;
